export default "__VITE_ASSET__BxCP0DPD__"